import React, {useState} from "react";
import styled from "styled-components";
import VideoPlayer from "../components/VideoPlayer";
import Chat from "../components/Chat";

const StreamPreview = () => {
  const [messages, setMessages] = useState([]);

  return (
    <Grid>
      <div>s</div>
      <div  style={{width: "100%", height: "500px"}}>
          <Chat
          // socketRef={socketRef}
          messages={messages}
          setMessages={setMessages}
          // onCollapse={handleCollapse}
          // isCollapsed={collapseChat}
          />

        <VideoPlayer
          type="rtmp/flv"
          src="https://www.rmp-streaming.com/media/big-buck-bunny-360p.mp4"
          isLive={false}
          isMute={true}
          autoPlay={true}
        />
      </div>
    </Grid>
  );
};

export default StreamPreview;

const Grid = styled.section`
  height: clamp(100%, 100%, 100%);
  background-color: ${({ theme }) => theme.color.secondaryBg};
  > div:nth-child(2) {
    height: clamp(100%, 100%, 100%);
    display: grid;
    grid-template-columns: 300px 1fr;
    grid-template-rows: auto;
  }
  /* div {
    border: 1px solid ${({ theme }) => theme.color.border};
  } */
`;
